class MobileMenuNew extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick = (event) => {
    if ( !(event.target instanceof Element) ) return;

    const trigger = event.target.closest('[data-mobile-menu-trigger]');
    if ( !(trigger instanceof HTMLButtonElement) || !this.contains(trigger) ) return;

    const selectedIndex = trigger.dataset.mobileMenuTrigger;

    const buttons = this.querySelectorAll('[data-mobile-menu-trigger]');
    for (const button of buttons) {
      const isActive = button === trigger;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', String(isActive));
    }

    const panels = this.querySelectorAll('[data-mobile-menu-panel]');
    for (const panel of panels) {
      if ( panel.getAttribute('data-mobile-menu-panel') !== selectedIndex ) {
        panel.setAttribute('hidden', '');
      } else {
        panel.removeAttribute('hidden');
      }
    }
    const tierTwo = this.querySelector('.mobile-menu-new__tier-two');
    if ( tierTwo ) {
      tierTwo.scrollTo({ top: 0 });
    }
  };
}

if ( !customElements.get('mobile-menu-new') ) {
  customElements.define('mobile-menu-new', MobileMenuNew);
}
